import {ActionType} from "typesafe-actions";
import IAnalyticsAction from "../IAnalyticsAction";
import {BonusType, getBonusGroup} from "../../../player/types";
import {consume} from "../../../payments/actions";
import {IApplicationState} from "../../../index";
import {IStoreProductConfiguration} from "../../../settings/types";

function getObject(bonus: BonusType) {
    switch (bonus) {
        case BonusType.None:
            return undefined;

        case BonusType.Coins:
            return "coin";

        case BonusType.Score:
            return "score";

        case BonusType.Lives:
            return "lives";

        default:
            return "bonus_" + getBonusGroup(bonus);
    }
}

export default function purchaseHandler({ payload }: ActionType<typeof consume.success>, { settings }: IApplicationState): IAnalyticsAction | undefined {
    const productConfiguration = settings.store.products.find((item: IStoreProductConfiguration) => item.productId === payload);

    if (!productConfiguration)
        return;

    return {
        category: "account",
        object: getObject(productConfiguration.bonus),
        name: "buy",
        addition: payload
    };
}